import { Injectable } from '@angular/core';

import { DataService } from 'src/app/shared/network/data.service';
import { GoogleSettings } from './google-settings';

@Injectable()
export class GoogleSettingsService {
    private readonly SETTINGS_KEY = 'google-settings';

    private settings: GoogleSettings = undefined;

    constructor(private dataService: DataService) { }

    public async getSettings(): Promise<GoogleSettings> {
        if (this.settings) {
            return this.settings;
        }
        try {
            const cachedSettings = localStorage.getItem(this.SETTINGS_KEY);
            if (cachedSettings) {
                let parsedSettings = JSON.parse(cachedSettings);
                if (parsedSettings.expirationDate > new Date()) {
                    this.settings = parsedSettings
                    return this.settings;
                }
            }
        } catch {
            //failed to load from cache - so be it
        }
        let settings = await this.dataService.get<GoogleSettings>('settings/google');
        let expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);
        settings.expirationDate = expirationDate;
        this.settings = settings;
        localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(this.settings));
        return this.settings;
    }
}
